import React from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import {
    ajaxArchiveFeedback,
    ajaxAssignEmployee,
    ajaxFeedback,
    ajaxFeedbackFilter,
    ajaxFeedbackFilterV2,
    ajaxUpdateFeedbackStatus,
    findWithAttr,
    getDepartmentFilter,
    getRatingsFilter,
    getTagFilter,
    reviewLinkSent,
    setCurrentPage,
    setLoading,
    setMaskedCall,
    setSelectedFeedback,
    updateModalContent,
} from '../redux/FeedbackRedux'
import {notifyError, notifySuccess} from '../ToastMessages'

class ActionSection extends React.Component {
    constructor(props) {
        super(props);
        this.handleForwardClick = this.handleForwardClick.bind(this);
        this.handleEmailClick = this.handleEmailClick.bind(this);
        this.handleCopyLinkClick = this.handleCopyLinkClick.bind(this);
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
        this.handleArchiveClick = this.handleArchiveClick.bind(this);
        this.handleStatusClick = this.handleStatusClick.bind(this);
        this.handleMaskedCallModalClick = this.handleMaskedCallModalClick.bind(this);
        this.emailSendHandler = this.emailSendHandler.bind(this);

        this.pageDetailDirection = null;
    }

    handleForwardClick() {
        event.preventDefault();
        const modal_id = "textForwardModal";
        const modal_title = __("Forward Via Text Message");
        const modal_body = "renderTextForward";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "send";
        const button_2_text = __("Send Text Message");
        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text
        }));
        jQuery('.modal:not(.error)').modal();
    }

    handleArchiveClick(event) {
        $(event.target).tooltip('dispose');

        if (this.props.state.feedback_detail.is_archived === 1) {
            event.preventDefault();
            this.props.dispatch(ajaxArchiveFeedback(this.props.state.feedback_detail.feedback_id));
            this.props.dispatch(ajaxFeedbackFilter(this.props.state.timeframe, this.props.state.status, this.props.state.feedback_detail.feedback_id, this.props.state.businesses ?? null, this.props.state.current_page, this.props.state.total_pages, this.props.state.query, this.props.state.other_filter, this.props.state.archive, this.props.state.department_ids ?? null, (this.props.state.region ? this.props.state.region.id : null), this.props.state.region_type ?? null));
        } else {
            event.preventDefault();
            const modal_id = "archiveModal";
            const modal_title = __("Archive Feedback");
            const modal_body = __('Archiving this Feedback will remove it from Feedback History and place it in "Feedback Archive" where it will be inaccessible to employees without manager privileges, and by default will not show up in reporting (unless specified)');
            const button_1_class = "primary";
            const button_1_id = "cancel";
            const button_1_text = __("Cancel");
            const button_2_class = "outline-secondary";
            const button_2_id = "archive";
            const button_2_text = __("Archive");
            this.props.dispatch(updateModalContent({
                modal_id: modal_id,
                modal_title: modal_title,
                modal_body: modal_body,
                button_1_class: button_1_class,
                button_1_id: button_1_id,
                button_1_text: button_1_text,
                button_2_class: button_2_class,
                button_2_id: button_2_id,
                button_2_text: button_2_text
            }));
            jQuery('.modal:not(.error)').modal();
        }
    }

    handleEmailClick(event) {
        event.preventDefault();
        const modal_id = "emailForwardModal";
        const modal_title = __("Forward Via Email/Text");
        const modal_body = "renderEmailForward";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "forward";
        const button_2_text = __("Forward");
        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text
        }));
        jQuery('.modal:not(.error)').modal();
    }

    // RTF-3700: copy the server-built share_url to the clipboard.
    async handleCopyLinkClick(event) {
        event.preventDefault();
        const shareUrl = this.props.state.feedback_detail?.share_url;

        if (!shareUrl) {
            notifyError(__('Link is not available for this feedback.'));
            return;
        }

        try {
            await navigator.clipboard.writeText(shareUrl);
            notifySuccess(__('Link copied to clipboard.'));
        } catch (error) {
            notifyError(__('Could not copy the link. Please try again.'));
        }
    }

    handleStatusClick(event) {
        event.preventDefault();
        let status = jQuery(event.target).attr('id');
        let hide_chat_modal = false;
        let hide_notes_modal = false;
        let hide_review_modal = false;

        if (this.props.state.feedback_detail.custom_qr_code) {
            hide_chat_modal = this.props.state.feedback_detail.custom_qr_code.hide_chat_modal;
            hide_notes_modal = this.props.state.feedback_detail.custom_qr_code.hide_notes_modal;
            hide_review_modal = this.props.state.feedback_detail.custom_qr_code.hide_review_modal;
        }

        if (status !== this.props.state.feedback_detail.status) {
            const id = this.props.state.feedback_detail.feedback_id;

            if (status === window.feedbackStatus.Open.value) {
                this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))

            } else if (status === window.feedbackStatus.Resolved.value) {
                const requireUnrespondedNote = Boolean(this.props.state.business.options?.resolve_unresponded_note);
                const isChatFeedback = this.props.state.feedback_detail.is_text === 1 || this.props.state.feedback_detail.is_whatsapp === 1;
                const isUnresponded = 0 === this.props.state.feedback_detail.chats.length;

                // RTF-5001: Require an internal note when resolving an unresponded chat/text
                // feedback, independently of the unrelated "warn if no review link sent"
                // setting (which previously short-circuited this flow). The m3 modal renders
                // the required internal-note textarea; Modal.js `setResolved` blocks until it
                // is filled in.
                if (requireUnrespondedNote && isChatFeedback && isUnresponded) {
                    this.props.dispatch(updateModalContent({
                        modal_type: 'm3',
                        modal_id: "statusModal",
                        modal_title: __("Update Status"),
                        button_1_class: "primary",
                        button_1_id: "cancel",
                        button_1_text: __("Cancel - I'll send them a review request link"),
                        button_2_class: "outline-primary",
                        button_2_id: "setResolved",
                        button_2_text: __("Continue without sending the link"),
                    }));
                    jQuery('.modal:not(.error)').modal();
                    return;
                }

                // If warnIfNoReviewLinkSent is not enabled, resolve without the review-link nudge.
                if (!this.props.state.business.options?.warn_if_no_review_link_sent) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state));
                    return;
                }

                if (this.props.state.feedback_detail.is_text === 0 && this.props.state.feedback_detail.is_whatsapp === 0) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()));
                    return;
                }

                if (isUnresponded) {
                    // The required-internal-note case is handled by the RTF-5001 guard above;
                    // reaching here means the note is not required, so only softly nudge the
                    // employee to send a chat.
                    const modal_id = "statusModal";
                    const modal_title = __("Update Status");
                    const modal_body = __("You are marking a Feedback as 'Resolved' where a chat/text response has been requested but no chat has been initiated by an employee. If the issue has been resolved, please consider sending them a chat to let them know, or consider adding notes to the system detailing how the feedback was resolved.");
                    const button_1_class = "primary";
                    const button_1_id = "cancel";
                    const button_1_text = __("Cancel - I'll send them a chat");
                    const button_2_class = "outline-primary";
                    const button_2_id = "setResolved";
                    const button_2_text = __("Continue without sending a chat");
                    this.props.dispatch(updateModalContent({
                        modal_id: modal_id,
                        modal_title: modal_title,
                        modal_body: modal_body,
                        button_1_class: button_1_class,
                        button_1_id: button_1_id,
                        button_1_text: button_1_text,
                        button_2_class: button_2_class,
                        button_2_id: button_2_id,
                        button_2_text: button_2_text
                    }));
                    jQuery('.modal:not(.error)').modal();
                    return;
                } else {
                    if (false === reviewLinkSent(this.props.state.feedback_detail.chats)
                        && this.props.state.feedback_detail.business.rating_request === 1
                        && this.props.state.feedback_detail.is_text === 1
                        && (this.props.state.feedback_detail.rating_page_id === null && this.props.state.feedback_detail.access_method !== 'AutoPilot SMS')) {
                        //M2
                        const modal_type = 'm2';
                        const modal_id = "statusModal";
                        const modal_title = __("Update Status");
                        const modal_body = __("You are marking a Feedback as 'Resolved' where a Review Request link has not yet been sent to the Feedbacker in chat. If the issue has been resolved, please consider sending them the Review Request link in chat. ");
                        const button_1_class = "primary";
                        const button_1_id = "cancel";
                        const button_1_text = __("Cancel - I'll send them a review request link");
                        const button_2_class = "outline-primary";
                        const button_2_id = "setResolved";
                        const button_2_text = __("Continue without sending the link");
                        this.props.dispatch(updateModalContent({
                            modal_type: modal_type,
                            modal_id: modal_id,
                            modal_title: modal_title,
                            modal_body: modal_body,
                            button_1_class: button_1_class,
                            button_1_id: button_1_id,
                            button_1_text: button_1_text,
                            button_2_class: button_2_class,
                            button_2_id: button_2_id,
                            button_2_text: button_2_text
                        }));
                        jQuery('.modal:not(.error)').modal();
                        return;
                    }
                }

                this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()));

            } else if (status === window.feedbackStatus.Pending.value) {
                const index = findWithAttr(this.props.state.feedback_detail.pendingreminders, "hashed_user_id", this.props.state.current_user);
                if (index !== false) {
                    this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
                } else {
                    const modal_id = "pendingModal";
                    const modal_title = __("Update Status");
                    const modal_body = "pendingModal"
                    const button_1_class = "outline-primary";
                    const button_1_id = "cancel";
                    const button_1_text = __("Cancel");
                    const button_2_class = "outline-primary";
                    const button_2_id = "setPending";
                    const button_2_text = __("Continue without setting a reminder");
                    this.props.dispatch(updateModalContent({
                        modal_id: modal_id,
                        modal_title: modal_title,
                        modal_body: modal_body,
                        button_1_class: button_1_class,
                        button_1_id: button_1_id,
                        button_1_text: button_1_text,
                        button_2_class: button_2_class,
                        button_2_id: button_2_id,
                        button_2_text: button_2_text
                    }));
                    jQuery('.modal:not(.error)').modal();
                }
            } else if (status === window.feedbackStatus.RatingsOnly.value) {
                this.props.dispatch(ajaxUpdateFeedbackStatus(id, status, this.props.state, getRatingsFilter(), getDepartmentFilter(), getTagFilter()))
            }
        }
    }

    handleHistoryClick() {
        event.preventDefault();
        const modal_id = "forwardHistoryModal";
        const modal_title = __("Forward History For This Feedback");
        const modal_body = "renderForwardHistory";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Close");
        const button_2_class = "hide";
        const button_2_id = "none";
        const button_2_text = __("none");
        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text
        }));
        jQuery('.modal:not(.error)').modal();
    }


    handleDepartmentClick(department_id, event) {
        if (this.props.state.feedback_detail.department_id !== department_id) {
            const modal_id = "departmentModal";
            const modal_title = __("Update Feedback's Department");
            const modal_body = "You are updating the department of this Feedback from " + this.props.state.feedback_detail.department.name + " to " + jQuery('.department-drop#' + department_id).text() + ". Would you like the employees (who normally receive new Feedback notifications for the " + jQuery('.department-drop#' + department_id).text() + " department) to receive notifications about this update?"
            const button_1_class = "outline-primary";
            const button_1_id = "sendQuiet";
            const button_1_text = __("No, update quietly");
            const button_2_class = "primary";
            const button_2_id = "sendLoud";
            const button_2_text = __("Yes, send notifications");
            window.findDepartment = department_id;
            this.props.dispatch(updateModalContent({
                modal_id: modal_id,
                modal_title: modal_title,
                modal_body: modal_body,
                button_1_class: button_1_class,
                button_1_id: button_1_id,
                button_1_text: button_1_text,
                button_2_class: button_2_class,
                button_2_id: button_2_id,
                button_2_text: button_2_text
            }));
            jQuery('.modal:not(.error)').modal();
        }
        event.preventDefault();
    }

    handleStatusHistoryClick(event) {
        if (jQuery(event.target).attr('data-toggle') !== 'open') {
            jQuery(event.target).attr('data-toggle', 'open');
            jQuery('body').find('.status-history').show();
        } else {
            jQuery(event.target).attr('data-toggle', 'closed');
            jQuery('body').find('.status-history').hide();
        }
    }

    handleAssignEmployee(employee, name, event) {
        event.preventDefault();
        if (this.props.state.feedback_detail.assigned_to !== employee) {
            this.props.dispatch(setLoading({loading: true, location: 'feedbackSection'}));
            this.props.dispatch(ajaxAssignEmployee(this.props.state.feedback_detail.feedback_id, employee, name));
        }
    }

    handleMaskedCallModalClick(event) {
        let feedback = this.props.state.feedback_detail;

        if (!feedback.user.phone) return
        this.props.dispatch(setMaskedCall(null));
        const modal_id = "maskedCallHelpModal";
        const modal_title = feedback.is_phone_call ? __('This Feedbacker has requested a phone response') : __('This Feedbacker has NOT requested a phone response');
        const modal_body = "maskedCall";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "initiateMaskedCall";
        const button_2_text = __("Let's Get Started");
        this.props.dispatch(updateModalContent({
            modal_id: modal_id,
            modal_title: modal_title,
            modal_body: modal_body,
            button_1_class: button_1_class,
            button_1_id: button_1_id,
            button_1_text: button_1_text,
            button_2_class: button_2_class,
            button_2_id: button_2_id,
            button_2_text: button_2_text
        }));
        jQuery('.modal:not(.error)').modal();
    }

    emailSendHandler (event) {
        if (!this.props.state.feedback_detail.user.email) {
            event.preventDefault();
        }
    }

    getfirstLast() {
        let firstIndex = this.props.state.initial_feedbacks ? 0 : null;
        let lastIndex = this.props.state.initial_feedbacks ? this.props.state.initial_feedbacks.length - 1 : null;

        return {
            first: firstIndex ? (this.props.state.initial_feedbacks[firstIndex].id || null) : null,
            last: lastIndex ? (this.props.state.initial_feedbacks[lastIndex].id || null) : null,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.state.initial_feedbacks !== prevProps.state.initial_feedbacks
            && this.pageDetailDirection !== null
        ) {
            let firstLast = this.getfirstLast();

            if (this.pageDetailDirection === 'next') {
                this.pageDetailDirection = null
                this.props.dispatch(setSelectedFeedback(firstLast.first));
                this.props.dispatch(ajaxFeedback(firstLast.first));

            } else if (this.pageDetailDirection === 'prev') {
                this.pageDetailDirection = null
                this.props.dispatch(setSelectedFeedback(firstLast.last));
                this.props.dispatch(ajaxFeedback(firstLast.last));
            }
        }
    }

    onPrevItemClick() {
        let prevId = this.props.state.feedback_detail.prev_id;

        if (prevId === null && this.props.state.current_page > 1) {
            this.doPagination('prev');
            return;
        } else if (prevId === null) {
            return;
        }

        this.props.dispatch(setSelectedFeedback(prevId));
        this.props.dispatch(ajaxFeedback(prevId));
    }

    onNextItemClick() {
        let nextId = this.props.state.feedback_detail.next_id;

        if (nextId === null && this.props.state.current_page !== Math.ceil(this.props.state.feedback_count / this.props.state.paginate_count)) {
            this.doPagination('next');
            return;
        } else if (nextId === null) {
            return;
        }

        this.props.dispatch(setSelectedFeedback(nextId));
        this.props.dispatch(ajaxFeedback(nextId));
    }

    doPagination(direction) {
        let e = event.target;
        let current = this.props.state.current_page;
        switch (direction) {
            case "next":
                current += 1;
                break;
            case "prev":
                current -= 1;
                break;
        }
        this.props.dispatch(setCurrentPage(current));
        this.props.dispatch(ajaxFeedbackFilterV2());
        this.pageDetailDirection = direction;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {
        let feedback = this.props.state.feedback_detail;
        const feedbackDate = moment.tz(new Date(feedback.created_at), this.props.state.business.call_at_timezone)
        let dow = (feedback.dow != "" ? feedback.dow + ", " : "") + feedbackDate.format('M/D/YYYY h:mm A z');
        let username = feedback.user.firstname ? feedback.user.firstname : "Anonymous" + " " + feedback.user.lastname ? feedback.user.lastname : "";
        let maskedCallText = __('Use Masked Call to call') + " " + username + " " + ('without displaying your phone number');
        const hasEmail = !!(feedback.user.email && String(feedback.user.email).trim())
        const hasPhone = !!(feedback.user.phone && String(feedback.user.phone).trim())

        return (
            <div className="d-flex align-items-center p-2 border-bottom w-100 actions-section-wrapper">
                {/* <div className="card-title"><span className="d-none d-sm-block mr-2">Feedback</span>Details</div>  */}
                <div className="pb-0 mb-0 text-default d-flex align-items-center mr-auto action-section">
                    {/* Change Status */}
                    {this.props.state.current_user &&
                        <div className="dropdown d-inline w-auto feedback-status-dropdown">
                            <span className="pl-2">{__("Change Status")}</span>
                            <button className="btn btn-outline-secondary dropdown-toggle status-dropdown-button mt-1"
                                    type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                {window.feedbackStatus[feedback.status].label}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item" id={window.feedbackStatus.Open.value}
                                   onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Open.label}</a>
                                <a className="dropdown-item" id={window.feedbackStatus.Pending.value}
                                   onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Pending.label}</a>
                                <a className="dropdown-item" id={window.feedbackStatus.Resolved.value}
                                   onClick={this.handleStatusClick} href="#">{window.feedbackStatus.Resolved.label}</a>
                                {this.props.state.businessHasAutoPilot && feedback.ratethisbizrating && !feedback.description ? (
                                    <a className="dropdown-item" id={window.feedbackStatus.RatingsOnly.value}
                                       onClick={this.handleStatusClick}
                                       href="#">{window.feedbackStatus.RatingsOnly.label}</a>) : null}
                            </div>
                        </div>
                    }

                    {/* Assign Department  */}
                    {this.props.state.current_user && feedback.department && feedback.business.departments && feedback.business.departments.length > 1 &&
                        <div className="dropdown d-inline w-auto lg:ml-2">
                            <span className="pl-2">{__("Department")}</span>
                            <button className="btn btn-outline-secondary dropdown-toggle mt-1" type="button"
                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                {feedback.department ? feedback.department.name : 'General'}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {feedback.business.departments.map((value, index) => {
                                    if (feedback.tellmyco && feedback.tellmyco.demo_request_industry) {
                                        if ((feedback.tellmyco.demo_request_industry === value.demo_request_industry) || value.is_general === 1) {
                                            return <a className="dropdown-item department-drop" key={index}
                                                      id={value.id}
                                                      onClick={this.handleDepartmentClick.bind(this, value.id)}
                                                      href="#">{value.name}</a>
                                        }
                                    } else {
                                        return <a className="dropdown-item department-drop" key={index} id={value.id}
                                                  onClick={this.handleDepartmentClick.bind(this, value.id)}
                                                  href="#">{value.name}</a>
                                    }
                                })
                                }
                            </div>
                        </div>
                    }

                    {/* Assign Employee */}
                    {this.props.employees && this.props.employees.length > 0 &&
                        <div className="dropdown d-inline w-auto lg:ml-2">
                            <span className="pl-2">{__('Assign Employee')}</span>
                            <button className="btn btn-outline-secondary dropdown-toggle mt-1" type="button"
                                    id="dropdownMenuButtonEmployee" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                {feedback.assigned_to ? feedback.assigned_to.firstname + ' ' + feedback.assigned_to.lastname : __('Assign employee')}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButtonEmployee">
                                {[...this.props.employees].sort((a, b) => ((a.firstname + a.lastname).localeCompare(b.firstname + b.lastname))).map((value, index) =>
                                    <a
                                        className="dropdown-item department-drop"
                                        key={index}
                                        id={value.user_id}
                                        onClick={this.handleAssignEmployee.bind(this, value.user_id, value.firstname + ' ' + value.lastname)}
                                        href="#">{value.firstname + ' ' + value.lastname + (value.title ? ` (${value.title})` : '')}</a>)}
                            </div>
                        </div>
                    }

                    {/* Quick Actions  */}
                    <div className="actions ml-2 d-inline align-items-center">
                        <span className="d-none d-xl-block">{__("Quick Actions")}</span>
                        <div className='d-flex align-items-end actions mt-1'>

                            {/* RTF-3700: Share menu */}
                            {this.props.state.current_user &&
                                <div className="dropdown share-dropdown mr-2 d-inline-flex align-items-end">
                                    <a
                                        href="#"
                                        role="button"
                                        className="share-icon d-inline-flex"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        title={__('Share')}
                                        style={{ lineHeight: 0 }}
                                        onClick={(e) => e.preventDefault()}>
                                        <svg
                                            width="22"
                                            height="22"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            style={{ display: 'block' }}
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="18" cy="5" r="2.6" stroke="#1C75BC" strokeWidth="2"/>
                                            <circle cx="6" cy="12" r="2.6" stroke="#1C75BC" strokeWidth="2"/>
                                            <circle cx="18" cy="19" r="2.6" stroke="#1C75BC" strokeWidth="2"/>
                                            <path
                                                d="m8.3 10.8 7.4-4.3M8.3 13.2l7.4 4.3"
                                                stroke="#1C75BC"
                                                strokeWidth="2"
                                                strokeLinecap="round"/>
                                        </svg>
                                    </a>
                                    <div className="dropdown-menu">
                                        <a className="dropdown-item" href="#"
                                           onClick={this.handleEmailClick}>{__('Forward Feedback')}</a>
                                        {this.props.state.feedback_detail?.share_url &&
                                            <a className="dropdown-item" href="#"
                                               onClick={this.handleCopyLinkClick}>{__('Copy Link')}</a>
                                        }
                                    </div>
                                </div>
                            }

                            {/* call */}
                            {feedback.is_phone_call
                                ?
                                <svg
                                    onClick={this.handleMaskedCallModalClick}
                                    className="call-icon"
                                    data-disabled={!hasPhone}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-title={hasPhone ? maskedCallText : __('No phone number provided')}
                                    width="25"
                                    height="24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <g>
                                            <path
                                                d="M20.677 21c-2.15 0-4.246-.48-6.287-1.438a19.045 19.045 0 0 1-5.425-3.8 19.045 19.045 0 0 1-3.8-5.425C4.205 8.296 3.727 6.2 3.727 4.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3h4.05a.96.96 0 0 1 .625.225.88.88 0 0 1 .325.575l.65 3.5c.033.233.029.446-.012.637a1.027 1.027 0 0 1-.288.513L7.702 10.9c.7 1.2 1.579 2.325 2.638 3.375A18.626 18.626 0 0 0 13.827 17l2.35-2.35c.15-.15.346-.263.588-.338.24-.075.478-.095.712-.062l3.45.7c.233.05.425.162.575.337.15.175.225.38.225.613v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3ZM6.752 9l1.65-1.65L7.977 5H5.752c.083.683.2 1.358.35 2.025.15.667.366 1.325.65 1.975Zm12.975 9.95v-2.2l-2.35-.475-1.675 1.675c.65.283 1.312.508 1.988.675.674.167 1.353.275 2.037.325Z"
                                                fill="#1C75BC"/>
                                        </g>
                                    </g>
                                </svg>
                                :
                                <svg
                                    onClick={this.handleMaskedCallModalClick}
                                    className="call-icon mr-2"
                                    data-disabled={!hasPhone}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-title={hasPhone ? maskedCallText : __('No phone number provided')}
                                    width="25"
                                    height="24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <g>
                                            <path
                                                d="M20.677 21c-2.15 0-4.246-.48-6.287-1.438a19.045 19.045 0 0 1-5.425-3.8 19.045 19.045 0 0 1-3.8-5.425C4.205 8.296 3.727 6.2 3.727 4.05c0-.3.1-.55.3-.75.2-.2.45-.3.75-.3h4.05a.96.96 0 0 1 .625.225.88.88 0 0 1 .325.575l.65 3.5c.033.233.029.446-.012.637a1.027 1.027 0 0 1-.288.513L7.702 10.9c.7 1.2 1.579 2.325 2.638 3.375A18.626 18.626 0 0 0 13.827 17l2.35-2.35c.15-.15.346-.263.588-.338.24-.075.478-.095.712-.062l3.45.7c.233.05.425.162.575.337.15.175.225.38.225.613v4.05c0 .3-.1.55-.3.75-.2.2-.45.3-.75.3ZM6.752 9l1.65-1.65L7.977 5H5.752c.083.683.2 1.358.35 2.025.15.667.366 1.325.65 1.975Zm12.975 9.95v-2.2l-2.35-.475-1.675 1.675c.65.283 1.312.508 1.988.675.674.167 1.353.275 2.037.325Z"
                                                fill="#1C75BC"/>
                                        </g>
                                    </g>
                                </svg>
                            }

                            {/* email */}
                            <a
                                id="start_email_button"
                                className="mr-2"
                                data-disabled={!hasEmail}
                                href={hasEmail ? 'mailto:' + feedback.user.email + '?subject=In Response To Your Feedback' : undefined}
                                onClick={this.emailSendHandler}
                                target="_blank"
                            >
                                <svg
                                    className="email-icon"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-title={hasEmail ? __('Reply via Email') : __('No email address provided')}
                                    width="25"
                                    height="24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <g>
                                            <path
                                                d="M4.727 20c-.55 0-1.021-.196-1.412-.587A1.927 1.927 0 0 1 2.727 18V6c0-.55.196-1.02.588-1.412A1.923 1.923 0 0 1 4.727 4h16c.55 0 1.02.196 1.413.588.39.391.587.862.587 1.412v12c0 .55-.196 1.021-.587 1.413a1.928 1.928 0 0 1-1.413.587h-16Zm16-12-7.475 4.675c-.084.05-.171.087-.263.112a.982.982 0 0 1-.262.038.98.98 0 0 1-.262-.038 1.026 1.026 0 0 1-.263-.112L4.727 8v10h16V8Zm-8 3 8-5h-16l8 5Zm-8-2.75V6.775 6.8v-.013V8.25Z"
                                                fill="#1C75BC"/>
                                        </g>
                                    </g>
                                </svg>
                            </a>

                            {/* history icon */}
                            <svg
                                onClick={this.handleStatusHistoryClick.bind(this)}
                                className="history-icon mr-2"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Status History')}
                                width="25"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="m13.727 11.6 2.5 2.5a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.949.949 0 0 1-.7.275.948.948 0 0 1-.7-.275l-2.8-2.8a1.03 1.03 0 0 1-.3-.725V8c0-.283.096-.521.288-.713A.967.967 0 0 1 12.727 7a.97.97 0 0 1 .713.287.97.97 0 0 1 .287.713v3.6Zm-1 9.4c-1.25 0-2.421-.237-3.512-.712a9.142 9.142 0 0 1-2.85-1.926 9.143 9.143 0 0 1-1.926-2.85A8.709 8.709 0 0 1 3.727 12c0-1.25.237-2.421.712-3.513a9.159 9.159 0 0 1 1.926-2.85 9.152 9.152 0 0 1 2.85-1.925A8.709 8.709 0 0 1 12.727 3c1.366 0 2.662.292 3.888.875a8.733 8.733 0 0 1 3.112 2.475V5c0-.283.096-.521.288-.713A.967.967 0 0 1 20.727 4c.283 0 .52.096.712.287.192.192.288.43.288.713v4c0 .283-.096.52-.288.712a.965.965 0 0 1-.712.288h-4a.965.965 0 0 1-.712-.288.965.965 0 0 1-.288-.712c0-.283.096-.521.288-.713A.967.967 0 0 1 16.727 8h1.75a7.432 7.432 0 0 0-2.525-2.2 6.75 6.75 0 0 0-3.225-.8c-1.95 0-3.604.679-4.962 2.037C6.405 8.396 5.727 10.05 5.727 12c0 1.95.679 3.604 2.038 4.962C9.123 18.321 10.777 19 12.727 19c1.533 0 2.92-.45 4.163-1.35a6.573 6.573 0 0 0 2.512-3.55c.083-.283.237-.521.463-.713a.825.825 0 0 1 .762-.187c.3.067.52.233.662.5.142.267.17.55.088.85-.55 1.917-1.625 3.47-3.225 4.662-1.6 1.192-3.409 1.788-5.425 1.788Z"
                                        fill="#1C75BC"/>
                                </g>
                            </svg>

                            {/* archive icon */}
                            {this.props.state.feedback_detail.is_archived !== 1 &&
                                <svg
                                    onClick={this.handleArchiveClick}
                                    className={`archive-icon reverse mr-2`}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-title={__('Archive Feedback')}
                                    width="25"
                                    height="24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path
                                            d="M5.727 21a1.93 1.93 0 0 1-1.413-.587A1.928 1.928 0 0 1 3.727 19V6.5c0-.25.041-.475.125-.675.083-.2.191-.392.325-.575l1.4-1.7c.133-.183.3-.321.5-.413.2-.091.416-.137.65-.137h12c.233 0 .45.046.65.137.2.092.366.23.5.413l1.4 1.7c.133.183.241.375.325.575.083.2.125.425.125.675V19a1.93 1.93 0 0 1-.587 1.413 1.928 1.928 0 0 1-1.413.587h-14Zm.4-15h13.2l-.85-1h-11.5l-.85 1Zm-.4 13h14V8h-14v11Zm7-1.425a1.1 1.1 0 0 0 .375-.063.872.872 0 0 0 .325-.212l2.6-2.6a.948.948 0 0 0 .275-.7.948.948 0 0 0-.275-.7.949.949 0 0 0-.7-.275.948.948 0 0 0-.7.275l-.9.9V11a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.967.967 0 0 0-.712.287.968.968 0 0 0-.288.713v3.2l-.9-.9a.949.949 0 0 0-.7-.275.948.948 0 0 0-.7.275.948.948 0 0 0-.275.7c0 .283.091.517.275.7l2.6 2.6c.1.1.208.17.325.212.116.042.241.063.375.063Z"
                                            fill="#1C75BC"/>
                                    </g>
                                </svg>
                            }

                            {/* unarchive icon */}
                            {this.props.state.feedback_detail.is_archived === 1 &&
                                <svg
                                    onClick={this.handleArchiveClick}
                                    className={`archive-icon mr-2 `}
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    data-title={__('Unarchive Feedback')}
                                    width="25"
                                    height="24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path
                                            d="M5.727 21c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3.727 19V6.5c0-.25.041-.475.125-.675.083-.2.191-.392.325-.575l1.4-1.7c.133-.183.3-.321.5-.413.2-.091.416-.137.65-.137h12c.233 0 .45.046.65.137.2.092.366.23.5.413l1.4 1.7c.133.183.241.375.325.575.083.2.125.425.125.675V19c0 .55-.196 1.021-.587 1.413a1.928 1.928 0 0 1-1.413.587h-14Zm.4-15h13.2l-.85-1h-11.5l-.85 1Zm-.4 13h14V8h-14v11Zm7-1.425a1.1 1.1 0 0 0 .375-.063.872.872 0 0 0 .325-.212l2.6-2.6a.948.948 0 0 0 .275-.7.948.948 0 0 0-.275-.7.949.949 0 0 0-.7-.275.948.948 0 0 0-.7.275l-.9.9V11a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.967.967 0 0 0-.712.287.968.968 0 0 0-.288.713v3.2l-.9-.9a.949.949 0 0 0-.7-.275.948.948 0 0 0-.7.275.948.948 0 0 0-.275.7c0 .283.091.517.275.7l2.6 2.6c.1.1.208.17.325.212.116.042.241.063.375.063Z"
                                            fill="#1C75BC"/>
                                    </g>
                                </svg>
                            }

                            {/* print icon */}
                            <svg width="25"
                                 height="24"
                                 data-toggle="tooltip"
                                 data-placement="bottom"
                                 data-title={__('Print Feedback')}
                                 onClick={() => window.print()}
                            >
                                <path fillRule="evenodd" clipRule="evenodd" d="M5 5c0-.55228.44772-1 1-1h12c.5523 0 1 .44772 1 1v6c1.6569 0 3 1.3431 3 3v4c0 1.6569-1.3431 3-3 3H5c-1.65686 0-3-1.3431-3-3v-4c0-1.6569 1.34315-3 3-3V5Zm0 8c-.55228 0-1 .4477-1 1v4c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1v-4c0-.5523-.4477-1-1-1v2c0 .5523-.4477 1-1 1H6c-.55228 0-1-.4477-1-1v-2Zm2-7v8h10V6H7Zm2 3c0-.55228.44772-1 1-1h4c.5523 0 1 .44772 1 1s-.4477 1-1 1h-4c-.55228 0-1-.44772-1-1Zm0 3c0-.5523.44772-1 1-1h4c.5523 0 1 .4477 1 1s-.4477 1-1 1h-4c-.55228 0-1-.4477-1-1Z" fill="#1C75BC"/>
                            </svg>

                        </div>
                    </div>

                    {/* Go To Actions  */}
                     <div className="actions ml-2 d-none d-xl-inline align-items-center">
                        <span>{__("Go To")}</span>
                        <div className='d-flex align-items-end actions mt-1'>
                            {/* go to: notes */}
                            <svg
                                className="notes-icon d-none d-xl-block mr-2"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Internal Notes')}
                                onClick={() => {document.getElementsByClassName("note-section")[1].scrollIntoView();}}
                                width="25"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="M5.727 19h14V9.825L14.902 5H5.727v14Zm0 2c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 0 1 3.727 19V5c0-.55.195-1.021.587-1.413A1.928 1.928 0 0 1 5.727 3h9.175a1.979 1.979 0 0 1 1.4.575l4.85 4.85a1.978 1.978 0 0 1 .575 1.4V19c0 .55-.196 1.021-.587 1.413a1.928 1.928 0 0 1-1.413.587h-14Zm3-4h8c.283 0 .52-.096.712-.288a.965.965 0 0 0 .288-.712.968.968 0 0 0-.288-.713.967.967 0 0 0-.712-.287h-8a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713c0 .283.095.52.287.712.192.192.43.288.713.288Zm0-4h8c.283 0 .52-.096.712-.288a.965.965 0 0 0 .288-.712.968.968 0 0 0-.288-.713.967.967 0 0 0-.712-.287h-8a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713c0 .283.095.52.287.712.192.192.43.288.713.288Zm0-4h5a.968.968 0 0 0 .713-.288.967.967 0 0 0 .287-.712.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287h-5a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713c0 .283.095.52.287.712.192.192.43.288.713.288Z" fill="#1C75BC"/>
                                </g>
                            </svg>

                            {/* go to: tags*/}
                            <svg
                                className="tags-icon d-none d-xl-block mr-2"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Tags')}
                                onClick={() => {document.getElementsByClassName("tag-section")[1].scrollIntoView();}}
                                width="25"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="M14.977 21.4c-.384.383-.859.575-1.425.575-.567 0-1.042-.192-1.425-.575l-8.8-8.8a2.069 2.069 0 0 1-.6-1.45V4c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 4.727 2h7.15c.283 0 .55.054.8.162.25.109.466.255.65.438l8.8 8.825c.383.383.575.854.575 1.412a1.92 1.92 0 0 1-.575 1.413l-7.15 7.15ZM13.552 20l7.15-7.15L11.877 4h-7.15v7.15L13.552 20ZM7.227 8c.416 0 .77-.146 1.062-.438.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.062A1.444 1.444 0 0 0 7.227 5c-.417 0-.771.146-1.062.438A1.444 1.444 0 0 0 5.727 6.5c0 .417.146.77.438 1.062.29.292.645.438 1.062.438Z" fill="#1C75BC"/>
                                    </g>
                            </svg>

                            {/* go to: attachments */}
                            <svg
                                className="attachments-icon d-none d-xl-block mr-2"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                data-title={__('Attachments')}
                                onClick={() => {document.getElementsByClassName("attachments")[1].scrollIntoView();}}
                                width="25"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="M12.227 22c-1.534 0-2.834-.533-3.9-1.6-1.067-1.067-1.6-2.367-1.6-3.9V6c0-1.1.391-2.042 1.175-2.825C8.685 2.392 9.627 2 10.727 2s2.041.392 2.825 1.175c.783.783 1.175 1.725 1.175 2.825v9.5c0 .7-.242 1.292-.725 1.775-.484.483-1.075.725-1.775.725s-1.292-.242-1.775-.725c-.484-.483-.725-1.075-.725-1.775V6.75a.726.726 0 0 1 .75-.75.728.728 0 0 1 .75.75v8.75c0 .283.096.52.288.712a.965.965 0 0 0 .712.288.968.968 0 0 0 .713-.288.967.967 0 0 0 .287-.712V6c0-.7-.242-1.292-.725-1.775-.484-.483-1.075-.725-1.775-.725s-1.292.242-1.775.725C8.468 4.708 8.227 5.3 8.227 6v10.5c0 1.1.391 2.042 1.175 2.825.783.783 1.725 1.175 2.825 1.175s2.041-.392 2.825-1.175c.783-.783 1.175-1.725 1.175-2.825V6.75a.726.726 0 0 1 .75-.75.728.728 0 0 1 .75.75v9.75c0 1.533-.534 2.833-1.6 3.9-1.067 1.067-2.367 1.6-3.9 1.6Z" fill="#1C75BC"/>
                                </g>
                            </svg>
                        </div>
                    </div>

                    {/* {feedback.is_internal ?
                        <b className="d-none d-sm-inline mr-2">{__('Submitted Internally')}</b> : null} */}
                </div>

                {feedback.status !== window.feedbackStatus.Resolved.value
                    && feedback.pendingreminders
                    && findWithAttr(feedback.pendingreminders, "hashed_user_id", this.props.state.current_user) !== false
                    && !feedback.pendingreminders[findWithAttr(feedback.pendingreminders, "hashed_user_id", this.props.state.current_user)].sent_at
                    &&
                    <h6 className='text-muted mb-0 reminder-text'>{"Reminder Set For: " + moment.utc(feedback.pendingreminders[findWithAttr(feedback.pendingreminders, "hashed_user_id", this.props.state.current_user)].remind_at, "YYYY-MM-DD HH:mm").clone().tz(moment.tz.guess()).format("M/D/YYYY, h:mm A z")}</h6>
                }

                {/* date of feedback + (for AutoPilot feedbacks) the date/time the rating-request text was sent */}
                <div className="d-none d-xl-block text-right">
                    <h4 className="font-bold mb-0">{dow}</h4>
                    {feedback.rating_request_sent_at_label &&
                        <h5 className="mb-0 mt-1 text-muted rating-request-sent">
                            {__('From a rating request text message sent')} {feedback.rating_request_sent_at_label}
                        </h5>
                    }
                </div>

                {/* {window.is_impersonating == 1 &&
                    <a href={"/feedback/" + feedback.feedback_id + "/generate-review"} target="_blank" className="btn btn-sm btn-secondary mr-3"><i className="far fa-star"></i></a>
                } */}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        employees: state.feedback_detail.assignable_employees
    }
}

export default connect(mapStateToProps)(ActionSection);
